var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"helpDetail"},[_c('el-card',{attrs:{"shadow":"never"}},[_c('h1',[_vm._v(_vm._s(_vm.detail.question))]),_c('h5',[_vm._v(_vm._s(_vm._f("timeFormat")(_vm.detail.createdAt,"yyyy-mm-dd MM:ss")))]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.detail.answer)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }